
export default `
    
<li id="#= data.id #">
    #= data.components #
</li>

`;
